import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const getIsAssignedToMeWork = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return (
        route === ERoutes.ASSIGNED_TO_ME_WORK ||
        route === ERoutes.ASSIGNED_TO_ME_WORK_ACTIVITY ||
        route === ERoutes.ASSIGNED_TO_ME_WORK_TIMING
    );
}
